export default "__VITE_ASSET__CQrVDHte__"